export const UploadType = {
  eventAsset: 1,
  contentAsset: 2,
  content: 3
};

export const eventStateEnum = {
  Draft: 1,
  Published: 2,
  Locked: 3,
  Active: 4,
  Completed: 5,
  Canceled: 6
}

export const actionType = {
  start: 1,
  progress: 2,
  pause: 3,
  resume: 4,
  complete: 5,
  seek: 6
}